import React, { forwardRef } from 'react'
import { CarouselItem } from './CarouselItem'
import { ApplicableFilter } from '../../../services/types/services'
import { useFindLocaleText } from '../../../text-localisation'
import { FilterSource } from '../../../types'
import { useSearchStore } from '../../../store/SearchStore'
import { Chip } from './Chip'

type FilterChipProps = {
  filter: ApplicableFilter
  select: boolean
}

const buildAriaLabel = (
  localiseText: ReturnType<typeof useFindLocaleText>,
  filter: ApplicableFilter,
  select: boolean,
) => {
  const group = filter.parent
  if (filter.__typename === 'IntegerFilter') {
    return localiseText('find.remove_facet_group_filter_facet_label', {
      group: filter.label,
      label: `${filter.integerId} ${
        filter.selectedValue ?? /* istanbul ignore next */ ''
      }`,
    })
  }
  return select
    ? localiseText('find.apply_facet_group_filter_facet_label', {
        group,
        label: filter.label.toLowerCase(),
      })
    : localiseText('find.remove_facet_group_filter_facet_label', {
        group,
        label: filter.label,
      })
}

export const FilterChip = forwardRef<HTMLLIElement, FilterChipProps>(
  ({ filter, select }, ref) => {
    const localiseText = useFindLocaleText()
    const toggleFilter = useSearchStore(store => store.toggleFilter)
    const clearFilters = useSearchStore(store => store.clearFilters)

    const ariaLabel = buildAriaLabel(localiseText, filter, select)

    const displayLabel =
      filter.__typename === 'IntegerFilter'
        ? filter.selectedValueLabel
        : filter.label

    return (
      <CarouselItem ref={ref}>
        <Chip
          dismissible
          selected={!select}
          onClick={() =>
            filter.__typename === 'IntegerFilter'
              ? clearFilters({
                  category: filter,
                  source: FilterSource.NextBestAction,
                })
              : toggleFilter({
                  filter,
                  select,
                  source: FilterSource.NextBestAction,
                })
          }
          aria-label={ariaLabel}
        >
          {displayLabel}
        </Chip>
      </CarouselItem>
    )
  },
)
